import axios from 'axios';

export const USER_SIGNED_UP_EMAIL_RESENT = 'USER_SIGNED_UP_EMAIL_RESENT';
export const USER_SIGNED_UP_EMAIL_RESENT_ERROR = 'USER_SIGNED_UP_EMAIL_RESENT_ERROR';

const resendSignUpEmail = email => (
  dispatch => (
    axios.post('/api/signup/resend', { email }).then((response) => {
      dispatch({
        type: USER_SIGNED_UP_EMAIL_RESENT,
        user: email,
      });

      return true;
    }).catch((error) => {
      dispatch({
        type: USER_SIGNED_UP_EMAIL_RESENT_ERROR,
        message: error.response.data.message,
        errors: error.response.data.errors,
      });

      return false;
    })
  )
);

export default resendSignUpEmail;
